export default __webpack_public_path__ + "static/media/SostieneLogo2.cbfd5eb5.png";